import React, { useState, useEffect, useRef } from 'react';
import { getStockHistoryList } from '../../../services/ProductService';
import Pagination from '../../constant/Pagination';
import { CancelRequest } from '../../../services/AxiosInstance';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import TableLoaderEffect from '../../constant/TableLoader';
import { connect } from 'react-redux';
import Select from 'react-select'
import StockHistoryTypeBadge from '../../constant/StockHistoryTypeBadge';

const statusBtnList = ["All", "In", "Out"]

const HistoryTypeOptiosList = [
    "NEW MATERIAL",
    "RETURN MATERIAL",
    "BORROWING MATERIAL",
    "MATERIAL CONSUMPTION",
    "RETURN BORROWED MATERIAL",
    "LENDING MATERIAL",
    "RECEIVE LENT MATERIAL"
]

const StockHistory = ({ stockUpdateKey }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [statusFilter, setStatusFilter] = useState(statusBtnList[0]);
    const [historyType, setHistoryType] = useState(null);
    const [historyTypeOtpion, setHistoryTypeOption] = useState(HistoryTypeOptiosList.map(item => ({ value: item, label: item })));
    const [data, setData] = useState([])
    const [total, setTotal] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const recordsPage = 25;
    const location = useLocation();
    const navigate = useNavigate()

    const isApiCalled = useRef(false); // Prevents duplicate API calls

    useEffect(() => {
        if (isApiCalled.current) return; // Skip second execution

        setIsLoading(true);
        const queryParams = new URLSearchParams(location.search);
        const query = queryParams.get("query") || searchQuery;

        getStockHistoryList(currentPage, recordsPage, query, statusFilter, historyType?.value || "")
            .then((resp) => {
                if (resp) {
                    setData(resp.data.data);
                    setTotal(resp.data.total);
                    setSearchQuery(query);

                    // Ensure we only remove `query` once to prevent re-triggering
                    if (queryParams.has("query")) {
                        isApiCalled.current = true; // Prevent second execution
                        navigate(location.pathname, { replace: true });
                    }
                }
            })
            .catch((error) => {
                console.log(error.response?.data?.message);
            })
            .finally(() => {
                setIsLoading(false);
            });

    }, [location.search, currentPage, recordsPage, statusFilter, stockUpdateKey, historyType]);

    const handlePagination = (page) => {
        isApiCalled.current = false;
        const new_page = page.selected + 1
        setCurrentPage(new_page)
    }

    const handleSearchChange = (e) => {
        const { value } = e.target
        if (value.length > 0) {
            CancelRequest()
        }
        getStockHistoryList(currentPage, recordsPage, value, statusFilter, historyType?.value || "").then((resp) => {
            if (resp) {
                setData(resp.data.data)
                setTotal(resp.data.total)
            }
        }).catch((error) => {
            console.log(error.response.data.message)
        })
        setSearchQuery(value)
    }

    const handleHistoryStatus = (status) => {
        isApiCalled.current = false;
        setStatusFilter(status)
        let HistoryOptiosList = ["NEW MATERIAL",
            "RETURN MATERIAL",
            "BORROWING MATERIAL",
            "MATERIAL CONSUMPTION",
            "RETURN BORROWED MATERIAL"]
        if (status === "In") {
            HistoryOptiosList = ["NEW MATERIAL", "RETURN MATERIAL", "BORROWING MATERIAL",]
        } else if (status === "Out") {
            HistoryOptiosList = ["MATERIAL CONSUMPTION", "RETURN BORROWED MATERIAL"]
        }
        setHistoryType(null)
        setHistoryTypeOption(HistoryOptiosList.map(item => ({ value: item, label: item })))
    }

    const handleHistoryTypeChange = (data) => {
        isApiCalled.current = false;
        setHistoryType(data)
    }


    return (
        <>
            {/* <MainPagetitle mainTitle="Employee" pageTitle={'Employee'} parentTitle={'Home'} />   */}
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Stock History</h4>
                                        <div className='d-flex align-items'>
                                            <button
                                                className="btn btn-primary tp-btn me-2"
                                                onClick={() => navigate("/borrwed-lent-stock")}
                                            >View Borrowed & Lent Stock</button>
                                            <Select
                                                value={historyType}
                                                onChange={(data) => handleHistoryTypeChange(data)}
                                                placeholder={"History Type"}
                                                isClearable={true}
                                                options={historyTypeOtpion}
                                                id={'history-type'}
                                                className='react-select me-2'
                                                classNamePrefix='select'
                                            />

                                            <div className="btn-group btn-group-sm" role="group" aria-label="Small button group">
                                                {statusBtnList.map(item => (
                                                    <button key={item} type="button"
                                                        className={`btn ${statusFilter === item ? "btn-primary" : "btn-outline-primary"}`}
                                                        onClick={() => handleHistoryStatus(item)}>{item}</button>
                                                ))}
                                            </div>

                                            <div className='form-group mx-5'>
                                                <input type="search" name="serach" className="form-control "
                                                    placeholder="Search" autoFocus
                                                    value={searchQuery} onChange={handleSearchChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Product</th>
                                                    <th>Rack</th>
                                                    <th>Quantity</th>
                                                    <th>Status</th>
                                                    <th>Date</th>
                                                    <th>Employee</th>
                                                    <th>Barcode</th>
                                                    <th>User</th>
                                                    <th>Source</th>


                                                </tr>
                                            </thead>
                                            <tbody>
                                                {isLoading ? <TableLoaderEffect colLength={9} /> : data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="d-flex flex-column">
                                                                <Link to={`/material/${item.stock.product.id}`} className='text-primary fw-bold'>{item.stock.product.name}</Link>
                                                                <small>{item.stock.product.ucs_code}</small>
                                                            </div>
                                                        </td>
                                                        <td><Link to={`/rack/${item.stock.rack.id}`}>{item.stock.rack ? item.stock.rack.rack_no : null}</Link></td>
                                                        <td><span>{item.quantity}</span></td>
                                                        <td>
                                                            {item.is_stock_out ? (
                                                                <span className={`badge light border-0 badge-danger`}>OUT</span>
                                                            ) : (
                                                                <span className={`badge light border-0 badge-success`}>IN</span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <div className="d-flex flex-column">
                                                                <span>{item.created_at}</span>
                                                                <div>
                                                                    <StockHistoryTypeBadge historyType={item.history_type} />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex flex-column">
                                                                <span>{item?.employee?.name || ""}</span>
                                                                <small>{item?.purpose || ""}</small>
                                                            </div>
                                                        </td>
                                                        <td><span>{item.stock.barcode_no}</span></td>
                                                        <td>
                                                            <div className="d-flex flex-column">
                                                                <span>{item.user?.name || "User Deleted"}</span>
                                                                <small>{item.user?.email}</small>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <span>{item.stock.source}</span>
                                                        </td>


                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                        {isLoading ? <div style={{ height: '4rem' }}></div> : <Pagination
                                            currentPage={currentPage}
                                            recordsPage={recordsPage}
                                            dataLength={total}
                                            handlePagination={handlePagination}
                                        />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
const mapStateToProps = (state) => {
    return {
        stockUpdateKey: state.auth.stockUpdateKey,
    };
};
export default connect(mapStateToProps)(StockHistory);